<template>
  <div class="emoji-code-container" :style="{ width: codeContainerWidth }">
    <single-emoji-code
        v-for="(singleCode, i) in codeParts"
        v-bind:key="i"
        :class="activeEmojiIndex === i ? 'emoji-code-active' : ''"
        v-bind:code="singleCode"
        v-bind:type="type"
        v-on:click.native="openEmojiSelector(i)"
    ></single-emoji-code>
    <div class="emoji-code-picker-container">
      <div class="emoji-code-picker">
        <div class="emoji-code-picker-header">
          <div
              :class="'emoji-code-picker-header-triangle-' + activeEmojiIndex"
              class="emoji-code-picker-header-triangle"
              :style="{ left: triangleLeft }"
          >
          </div>
        </div>
        <div class="emoji-code-picker-emojis">
          <div class="emoji-code-picker-emojis-inside">
            <div
                v-for="(n, index) in 9"
                :class="codeParts[activeEmojiIndex] === n ? 'emoji-code-active' : ''"
                class="emoji-code-picker-emoji"
                v-on:click="selectEmojiCode(n)"
            >
              <img :src="emojis[index]">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SingleEmojiCode from './single-emoji-code'
import emojis from './emojis.js'
import {mapGetters} from 'vuex';

export default {
  name: 'emoji-code',
  components: {
    SingleEmojiCode
  },
  props: {
    type: {
      type: String,
      required: false,
      default: 'default'
    },
    value: {
      type: String,
      required: true
    },
    activeEmojiIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters({
      features: 'getFeatures',
    }),
    codeContainerWidth() {
      let codeContainerWidth = 15 + (60 * this.emojiLength);

      return codeContainerWidth + 'px';
    },
    triangleLeft() {
      let totalWidth = this.codeContainerWidth.replace(/px$/, '');
      let triangleWidth2 = 15;
      let percent = this.activeEmojiIndex / (this.emojiLength - 1);

      let padding = 40;
      let startX = padding;
      let endX = totalWidth - padding;

      let triangleLeft = startX + ((endX - startX) * percent) - triangleWidth2;

      return triangleLeft + 'px';
    },
    emojiLength() {
      return this.features.roomIdLength;
    }
  },
  data() {
    // Cast all values to numbers
    return {
      emojis: emojis,
      codeParts: []
    }
  },
  watch: {
    value(newValue) {
      this.codeParts = this.getCodePartsFromValue(newValue);
    }
  },
  mounted() {
    this.codeParts = this.getCodePartsFromValue(this.value);
  },
  methods: {
    getCodePartsFromValue(value) {
      while (value.length < this.emojiLength) {
        value += '0';
      }

      let codeParts = value.split(/(?=.)/g)

      // Cast all values to numbers
      codeParts = codeParts.map(Number)

      return codeParts;
    },
    openEmojiSelector(index) {
      this.$emit('activeEmojiIndexChange', index)
    },
    selectEmojiCode(emojiCode) {
      let emojiCodeEmptyCountPre = this.codeParts.filter(code => code === 0).length

      this.$set(this.codeParts, this.activeEmojiIndex, emojiCode)

      this.$emit('input', this.codeParts.join(''))

      // Iterate through each codePart and count how many "0"'s are found and check if the total count is 0
      let emojiCodeEmptyCountPost = this.codeParts.filter(code => code === 0).length

      if (emojiCodeEmptyCountPre !== emojiCodeEmptyCountPost) {
        this.$emit('fillOutStatusChanged', emojiCodeEmptyCountPost === 0)
      }

      if (this.activeEmojiIndex < this.codeParts.length) {
        // If the next one is empty
        let nextEmojiIndex = this.activeEmojiIndex + 1;

        if (this.codeParts[nextEmojiIndex] || this.codeParts[nextEmojiIndex] === 0) {
          this.$emit('activeEmojiIndexChange', nextEmojiIndex)
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "~@less/mixins/less-triangle.less";
@import "~@less/variables.less";

.emoji-code-container {
  width: 100%;
  text-align: center;
  margin: 0 auto;

  .emoji-code {
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &:hover, &.emoji-code-active {
      transform: scale(1.1);
    }
  }
}

.emoji-code-picker-container {
  margin: 20px auto 20px auto;
}

.emoji-code-picker-container,
.emoji-code-picker {
  width: 100%;
}

.emoji-code-picker {
  .emoji-code-picker-emojis-inside {
    width: 225px;
  }

  .emoji-code-picker-header {
    position: relative;
    top: -15px;

    .emoji-code-picker-header-triangle {
      .triangle(up, 15px, @white);
      position: absolute;
      transition: all 0.2s ease-in-out;

      &.emoji-code-picker-header-triangle-0 {
        left: 10px;
      }

      &.emoji-code-picker-header-triangle-1 {
        left: 70px;
      }

      &.emoji-code-picker-header-triangle-2 {
        left: 130px;
      }

      &.emoji-code-picker-header-triangle-3 {
        left: 190px;
      }
    }
  }

  .emoji-code-picker-emojis {
    background-color: rgba(@white, 0.3);
    border-radius: 10px;
    border: 2px solid white;
    padding: 10px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;

    .emoji-code-picker-emoji {
      position: relative;
      display: inline-block;
      width: 50px;
      height: 50px;
      margin: 10px;
      transition: all 0.2s ease-in-out;
      cursor: pointer;
      border: 2px solid transparent;

      &:hover, &.emoji-code-active {
        border: 2px solid @main-color !important;
      }

      img {
        max-width: 100%;
        max-height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
</style>